import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import AuthGuard from '@/components/AuthGuard'
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import Sources from '@/pages/Sources'
import SourceDetails from '@/pages/SourceDetails'
import ScanJobs from '@/pages/ScanJobs'
import ScanDetails from '@/pages/ScanDetails'
import Assets from '@/pages/Assets'
import Reports from '@/pages/Reports'
import Settings from '@/pages/Settings'
import Sbom from '@/pages/Packages'
import Inventories from '@/pages/Inventories'
import InventoryDetails from '@/pages/InventoryDetails'
import SbomHistory from '@/pages/SbomHistory'
import CbomHistory from '@/pages/CbomHistory'
import CmdbPage from '@/pages/CmdbPage'
import CmdbHandlerDetail from '@/pages/CmdbHandlerDetail'
import CmdbMappingProfiles from '@/pages/CmdbMappingProfiles'
import CmdbOutboundProfiles from '@/pages/CmdbOutboundProfiles'
import CmdbImportExport from '@/pages/CmdbImportExport'
import Credentials from '@/pages/Credentials'

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <AuthGuard>
            <Layout />
          </AuthGuard>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="sources" element={<Sources />} />
        <Route path="sources/new" element={<Navigate to="/sources?new=true" replace />} />
        <Route path="sources/:id" element={<SourceDetails />} />
        <Route path="sources/:id/sbom-history" element={<SbomHistory />} />
        <Route path="sources/:id/cbom-history" element={<CbomHistory />} />
        <Route path="scans" element={<ScanJobs />} />
        <Route path="scans/:id" element={<ScanDetails />} />
        <Route path="assets" element={<Assets />} />
        <Route path="packages" element={<Sbom />} />
        <Route path="inventories" element={<Inventories />} />
        <Route path="inventories/:id" element={<InventoryDetails />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings />} />
        <Route path="cmdb" element={<CmdbPage />} />
        <Route path="cmdb/handlers/:id" element={<CmdbHandlerDetail />} />
        <Route path="cmdb/mapping-profiles" element={<CmdbMappingProfiles />} />
        <Route path="cmdb/outbound-profiles" element={<CmdbOutboundProfiles />} />
        <Route path="cmdb/import-export" element={<CmdbImportExport />} />
        <Route path="credentials" element={<Credentials />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}

export default App
